<template>
  <div class="admin-dashboard">
    <header-title title="Dashboard - Principal"></header-title>

    <Loader :dialog-loader="loader" message="Cargando..."></Loader>

    <v-container fluid class="px-0">
      <v-row>
        <v-col lg="12" md="12" sm="12">
          <v-card class="mx-auto text-center" dark>
            <v-card-text class="font-weight-bold">
              ÛLTIMO CIERRE DE CAJA
            </v-card-text>
            <v-card-text class="font-weight-bold">
              {{ formatDateTime2(openingTime) }}
              -
              {{ closingTime }}
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <LastClosureTable
                  :lastZclosure="lastZclosure"
                  :lastYearZclosure="lastYearZclosure"
                  :labelDataset1="openingTime"
                  :labelDataset2="lastYearZclosureDate"
                ></LastClosureTable>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" lg="2" md="6" sm="6" xs="12">
          <v-select
            @change="onChangeDatePeriod"
            v-model="dateSelected"
            :items="dateDropdown"
            item-text="label"
            item-value="value"
            dense
            label="Selecciona un período"
            class="filters"
            outlined
            hide-details
          ></v-select>
        </v-col>

        <v-col cols="12" lg="2" md="6" sm="6" xs="12">
          <v-menu
            v-model="menu2"
            class="pt-0"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Date range"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :first-day-of-week="1"
              v-model="dates"
              @change="onChangeDate"
              range
              locale="es"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" lg="2" md="6" sm="6" xs="12">
          <v-select
            @change="onChangeProductType"
            v-model="productTypeSelected"
            :items="typeDropdown"
            item-text="label"
            item-value="value"
            dense
            label="Tipo de producto"
            class="filters"
            outlined
            hide-details
          ></v-select>
        </v-col>

        <v-col cols="12" lg="2" md="6" sm="6" xs="12">
          <v-btn dark @click="refreshData" class="filters">
            <v-icon dark> mdi-refresh </v-icon>
            &nbsp;Refrescar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-alert v-if="loader" type="info" prominent outlined>
      <v-row align="center">
        <v-col class="grow">Recopilando datos. Volveremos pronto!</v-col>
      </v-row>
    </v-alert>

    <v-container v-if="!loader" class="dashboard-container">
      <h2 class="font-weight-bold">
        {{ dayFormat2(rangeOfDates.start) }} -
        {{ dayFormat2(rangeOfDates.end) }}
      </h2>
      <br />

      <v-row>
        <v-col lg="12" md="12" sm="12">
          <v-card class="mx-auto text-center" dark>
            <v-card-text class="font-weight-bold">
              MÉTRICAS DE LAS VENTAS
            </v-card-text>

            <v-card-text>
              <v-sheet>
                <metrics-table
                  :orders="orders"
                  :orders-last-year="ordersLastYear"
                  :label-dataset1="labelDataset1"
                  :label-dataset2="labelDataset2"
                  :product-type-selected="productTypeSelected"
                ></metrics-table>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <v-card
            class="mx-auto text-center"
            dark
            max-width="1800"
            max-height="480"
          >
            <v-card-text class="font-weight-bold">
              INGRESOS DIARIOS
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <daily-revenue-chart
                  :orders="orders"
                  :orders-last-year="ordersLastYear"
                  :label-dataset1="labelDataset1"
                  :label-dataset2="labelDataset2"
                  :product-type-selected="productTypeSelected"
                ></daily-revenue-chart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card
            class="mx-auto text-center"
            dark
            max-width="900"
            max-height="480"
          >
            <v-card-text class="font-weight-bold">
              INGRESOS POR MES
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <orders-revenue-by-month-chart
                  :orders="allOrdersInCurrentYear"
                  :orders-last-year="allOrdersLastYear"
                  :label-dataset1="labelYearDataset1"
                  :label-dataset2="labelYearDataset2"
                  :product-type-selected="productTypeSelected"
                ></orders-revenue-by-month-chart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card
            class="mx-auto text-center"
            dark
            max-width="900"
            max-height="480"
          >
            <v-card-text class="font-weight-bold">
              INGRESOS POR SEMANA / DIA
            </v-card-text>

            <v-card-text>
              <v-sheet>
                <orders-by-month-chart
                  :orders="allOrdersInCurrentYear"
                  :orders-last-year="allOrdersLastYear"
                  :label-dataset1="labelDataset1"
                  :label-dataset2="labelDataset2"
                  :product-type-selected="productTypeSelected"
                ></orders-by-month-chart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card
            class="mx-auto text-center"
            dark
            max-width="900"
            max-height="480"
          >
            <v-card-text class="font-weight-bold"> TOP PRODUCTOS </v-card-text>
            <v-card-text>
              <v-sheet>
                <top-products-chart
                  :orders="orders"
                  :product-type-selected="productTypeSelected"
                ></top-products-chart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card
            class="mx-auto text-center"
            dark
            max-width="900"
            max-height="480"
          >
            <v-card-text class="font-weight-bold">
              METODOS DE PAGO
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <top-payments-chart :orders="orders"></top-payments-chart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HeaderTitle from "@/components/admin/common/HeaderTitle";
import OrdersByMonthChart from "@/components/admin/dashboard/OrdersByMonthChart";
import DailyRevenueChart from "@/components/admin/dashboard/DailyRevenueChart";
import TopProductsChart from "@/components/admin/dashboard/TopProductsChart";
import TopPaymentsChart from "@/components/admin/dashboard/TopPaymentsChart";
import MetricsTable from "@/components/admin/dashboard/MetricsTable";
import LastClosureTable from "@/components/admin/dashboard/LastClosureTable";
import OrdersRevenueByMonthChart from "@/components/admin/dashboard/OrdersRevenueByMonthChart";
import Loader from "@/components/common/Loader";
import moment from "moment";
import { getDateFilter, getProductType } from "@/utils/constant";
import dashboardMixin from "@/mixins/dashboard/dashboardMixin";
import {
  zClosuresCollection,
  getZClousureByRangeOfDates,
  getOneZClousureByRangeOfDates
} from "@/collections/zClousures.js";

const TODAY_VALUE = "today";
const LAST_MONTH_VALUE = "lastMonth";
const LAST_3MONTHS_VALUE = "last3Month";
const LAST_6MONTHS_VALUE = "last6Month";
const LAST_YEAR_VALUE = "lastYear";
const INITIAL_DATE_START = moment().startOf("day");
const INITIAL_DATE_END = moment().endOf("day");

export default {
  name: "Dashboard",
  mixins: [dashboardMixin],
  components: {
    MetricsTable,
    OrdersByMonthChart,
    DailyRevenueChart,
    TopProductsChart,
    OrdersRevenueByMonthChart,
    Loader,
    HeaderTitle,
    TopPaymentsChart,
    LastClosureTable
  },
  data() {
    return {
      loader: false,
      dateDropdown: [...getDateFilter],
      typeDropdown: [...getProductType],
      popover: {
        visibility: "click"
      },
      rangeOfDates: {},
      rangeOfDatesLastYear: {
        start: null,
        end: null
      },
      dateSelected: "today",
      productTypeSelected: "all",
      orderHistory: [],
      orderHistoryLastYear: [],
      allOrdersInCurrentYear: [],
      allOrdersInLastYear: [],
      zClosuresLastDoc: [],
      lastYearZclosure: [],
      menu2: false,
      dates: [
        moment(INITIAL_DATE_START).format("YYYY-MM-DD"),
        moment(INITIAL_DATE_END).format("YYYY-MM-DD")
      ]
    };
  },
  firestore() {
    return {
      zClosuresLastDoc: zClosuresCollection
        .orderBy("opened_on", "desc")
        .limit(1)
    };
  },
  computed: {
    orders() {
      return [...this.orderHistory];
    },
    ordersLastYear() {
      return [...this.orderHistoryLastYear];
    },
    allOrdersLastYear() {
      return [...this.allOrdersInLastYear];
    },
    labelDataset1() {
      return `${this.dayFormat2(this.rangeOfDates.start)}-${this.dayFormat2(
        this.rangeOfDates.end
      )}`;
    },
    labelDataset2() {
      return `${this.dayFormat2(
        this.rangeOfDatesLastYear.start
      )}-${this.dayFormat2(this.rangeOfDatesLastYear.end)}`;
    },
    labelYearDataset1() {
      return `${this.yearFormat1(this.rangeOfDates.start)}`;
    },
    labelYearDataset2() {
      return `${this.yearFormat1(this.rangeOfDatesLastYear.start)}`;
    },
    lastZclosure() {
      return this.zClosuresLastDoc?.length > 0
        ? this.zClosuresLastDoc[this.zClosuresLastDoc.length - 1]
        : {};
    },
    openingTime() {
      return (
        moment(this.lastZclosure?.opened_on?.seconds * 1000).toDate() ||
        moment()
          .startOf("day")
          .toDate()
      );
    },
    closingTime() {
      return this.lastZclosure?.closed_on !== null
        ? this.formatDateTime2(
            moment(this.lastZclosure?.closed_on?.seconds * 1000).toDate()
          )
        : "SIN FECHA DE CIERRE";
    },
    lastYearZclosureDate() {
      return moment(this.lastZclosure?.opened_on?.seconds * 1000)
        .subtract(1, "year")
        .toDate();
    },
    dateRangeText() {
      return this.dates?.join(" ~ ");
    }
  },
  mounted() {
    this.dateSelected = "lastMonth";
    this.onChangeDatePeriod();
    setTimeout(async () => {
      await this.getLastYearZClosure(this.lastZclosure?.opened_on);
    }, 3000);
  },
  methods: {
    onChangeDatePeriod() {
      this.productTypeSelected = "all";

      const INITIAL_DATE_START = moment().startOf("day");
      const INITIAL_DATE_END = moment().endOf("day");

      if (this.dateSelected === TODAY_VALUE) {
        this.rangeOfDates = {
          start: INITIAL_DATE_START,
          end: INITIAL_DATE_END
        };
      }
      if (this.dateSelected === LAST_MONTH_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(1, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_3MONTHS_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(3, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_6MONTHS_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(6, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_YEAR_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(1, "year");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }
      this.dates = [];
      this.dates[0] = moment(this.rangeOfDates.start).format("YYYY-MM-DD");
      this.dates[1] = moment(this.rangeOfDates.end).format("YYYY-MM-DD");
      this.onChangeDate(this.dates);
    },
    refreshData() {
      this.loader = true;
      let _date = [];
      _date[0] = this.rangeOfDates.start;
      _date[1] = this.rangeOfDates.end;
      this.onChangeDate(_date);
    },
    async onChangeDate(_date) {
      this.menu2 = false;
      this.loader = true;
      this.rangeOfDates = {};
      this.rangeOfDates = {
        start: moment(_date[0])?.toDate(),
        end: moment(_date[1])?.toDate()
      };
      // Range selected
      this.rangeOfDates = await this.buildRangeOfDates(this.rangeOfDates);

      //get orders history
      this.ordersByRangeOfDate(this.rangeOfDates);

      // Last year
      this.rangeOfDatesLastYear = this.buildRangeOfDatesLastYear(
        this.rangeOfDates
      );

      //get orders last year history
      this.ordersByRangeOfDatesLastYear(this.rangeOfDatesLastYear);

      await this.onChangeYear();

      setTimeout(() => {
        this.loader = false;
      }, 3000);
    },
    async onChangeYear() {
      // Range selected for current year
      this.ordersInYear(this.rangeOfDates.start, this.rangeOfDates.end);

      // Last year
      let lastYearStartTime = moment(this.rangeOfDates.start)
        .subtract(1, "year")
        .toDate();
      let lastYearEndTime = moment(this.rangeOfDates.end)
        .subtract(1, "year")
        .toDate();
      this.ordersInLastYear(lastYearStartTime, lastYearEndTime);
    },
    onChangeProductType(value) {
      this.productTypeSelected = value;
    },
    async ordersByRangeOfDate(rangeOfDates) {
      try {
        this.orderHistory = await getZClousureByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
      } catch (error) {
        this.setlogError(
          "get_zclousure_date_range",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async ordersByRangeOfDatesLastYear(rangeOfDates) {
      try {
        this.orderHistoryLastYear = await getZClousureByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
      } catch (error) {
        this.setlogError(
          "get_last_year_zclousure_date_range",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async ordersInYear(startYearTime, endYearTime) {
      try {
        this.allOrdersInCurrentYear = await getZClousureByRangeOfDates(
          startYearTime,
          endYearTime
        );
      } catch (error) {
        this.setlogError(
          "get_orders_in_year",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async ordersInLastYear(startYearTime, endYearTime) {
      try {
        this.allOrdersInLastYear = await getZClousureByRangeOfDates(
          startYearTime,
          endYearTime
        );
      } catch (error) {
        this.setlogError(
          "get_orders_in_last_year",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async getLastYearZClosure(date) {
      let start = moment(date.seconds * 1000)
        .startOf("day")
        .subtract(1, "year")
        .toDate();
      let end = moment(date.seconds * 1000)
        .endOf("day")
        .subtract(1, "year")
        .toDate();
      try {
        this.lastYearZclosure = await getOneZClousureByRangeOfDates(start, end);
      } catch (error) {
        this.setlogError(
          "get_one_last_year_zclousure",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
::v-deep {
  .vc-popover-content-wrapper {
    @media screen and (max-width: 471px) {
      width: 80%;
      overflow: hidden;
    }
  }
  .vc-popover-content {
    @media screen and (max-width: 471px) {
      width: 95%;
      overflow: auto;
    }
  }
}
</style>
